/**
 * 利用生協
 * 
 */
export class GoodsCoopStatus {
  coopCode: string; 
  disabled: boolean;
  checked: boolean;

  constructor(coopCode: string = '', disabled: boolean = true, checked: boolean = false) {
    this.coopCode = coopCode;
    this.disabled = disabled;
    this.checked = checked;
  }

  /**
   * 活性状態
   * 
   * @param codeList 利用可能生協
   * @returns 
   */
  setDisabled(codeList: string[]) {
    //　利用可能生協に含まれていれば活性
    this.disabled = !codeList.includes(this.coopCode);
    return this.disabled;
  }

  /**
   * チェック状態
   * 
   * @param codeList 利用生協
   * @returns 
   */
  setChecked(codeList: string[]) {
    // 利用生協に含まれていればチェック
    return this.checked = codeList.includes(this.coopCode);
  }
}